module.exports = __webpack_public_path__ + "img/Mage-gnome-m-70.f69847c7.gif";